import React from "react";
import date from '../../static/updateDate';

function Footer() {
  return (
    <div class="footer">
      <p>Page mise à jour le {date}.</p>
    </div>
  ); 
}

export default Footer;